
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import {
  dateNotTimezone,
  getOneDate,
  pickerOptions,
  dateToSeconds
} from '@/utils/dateTime'
import { agentDetail, agentList } from '@/api/report'
import moment from 'moment'

@Component({
  name: 'agent',
  components: {}
})
export default class extends Vue {
  private queryForm: any = {
    merchant_no: '',
    start_day: null,
    end_day: null
  }
  private date: any[] = getOneDate()
  private pickerOptions = pickerOptions

  private total = 0
  private list: any[] = []
  private listLoading: Boolean = false

  @Watch('date', { immediate: true })
  // 创建时间监听
  private pickerChange() {
    if (this.date) {
      let a: any = dateToSeconds(this.date[0])
      let b: any = dateToSeconds(this.date[1])
      const date1 = moment(a * 1000).format('YYYY-MM-DD')
      const date2 = moment(b * 1000).format('YYYY-MM-DD')
      this.queryForm.start_day = date1
      this.queryForm.end_day = date2
    } else {
      this.queryForm.start_day = null
      this.queryForm.end_day = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  private reset() {
    this.queryForm = {
      merchant_no: '',
      start_day: null,
      end_day: null
    }
    this.currentPage = 1
    this.date = getOneDate()
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await agentList(data)
        .then((res: any) => {
          this.total = res.count
          this.list = res.results
          this.listLoading = false
        })
        .catch(e => {
          this.listLoading = false
        })
    } catch (error) {
      this.listLoading = false
    }
  }

  private drawerVisble: Boolean = false
  private drawerList: any[] = []
  private drawerLoading: boolean = false
  private drawerInfo: any = {}
  private drawerTotal: number = 0

  private async openDrawer(row: any) {
    this.drawerVisble = true
    this.drawerInfo = row
    await this.getAgentDetail()
  }

  // 分页器设置
  private drawerpagesize: number = 0
  private drawerhandleSizeChange(size) {
    this.drawerpagesize = size
    this.getAgentDetail()
  }

  // 分页切换
  private drawercurrentPage: number = 1
  private drawerhandleCurrentChange(currentPage) {
    this.drawercurrentPage = currentPage
    this.getAgentDetail()
  }

  private async getAgentDetail() {
    this.drawerLoading = true
    let data = {
      merchant_no: this.drawerInfo.merchant_no,
      day: this.drawerInfo.create_time,
      page_size: this.drawerpagesize,
      page: this.drawercurrentPage
    }
    await agentDetail(data).then((res: any) => {
      this.drawerTotal = res.count
      this.drawerList = res.results
      this.drawerLoading = false
    })
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''
  private async init() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.agent`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
  mounted() {
    this.init()
  }
}
